export const urls = {
  register: `/v6/users`,
}
